import { compose, withProps } from 'recompose';
import withRoleIdType from './withRoleIdType';

export default baseUrl => compose(
  withRoleIdType,
  withProps((props) => {
    switch (true) {
      case (props.roleIdType.type === 'brand'):
        return { baseUrl: `/brand${baseUrl}` };
      case (props.roleIdType.type === 'barber'):
        return { baseUrl: `/barber${baseUrl}` };
      default:
        return { baseUrl };
    }
  }),
);
